import React, { ComponentProps, FunctionComponent } from "react";

const CalenderOutlineIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M13.1111 0C13.8773 0 14.6121 0.304364 15.1539 0.846136C15.6956 1.38791 16 2.12271 16 2.88889V13.1111C16 13.8773 15.6956 14.6121 15.1539 15.1539C14.6121 15.6956 13.8773 16 13.1111 16H2.88889C2.12271 16 1.38791 15.6956 0.846136 15.1539C0.304364 14.6121 0 13.8773 0 13.1111V2.88889C0 2.12271 0.304364 1.38791 0.846136 0.846136C1.38791 0.304364 2.12271 0 2.88889 0H13.1111ZM14.6667 4.88889H1.33333V13.1111C1.33333 13.9698 2.03022 14.6667 2.88889 14.6667H13.1111C13.5237 14.6667 13.9193 14.5028 14.2111 14.2111C14.5028 13.9193 14.6667 13.5237 14.6667 13.1111V4.88889ZM4.22222 10.2222C4.51691 10.2222 4.79952 10.3393 5.0079 10.5477C5.21627 10.756 5.33333 11.0386 5.33333 11.3333C5.33333 11.628 5.21627 11.9106 5.0079 12.119C4.79952 12.3274 4.51691 12.4444 4.22222 12.4444C3.92754 12.4444 3.64492 12.3274 3.43655 12.119C3.22817 11.9106 3.11111 11.628 3.11111 11.3333C3.11111 11.0386 3.22817 10.756 3.43655 10.5477C3.64492 10.3393 3.92754 10.2222 4.22222 10.2222ZM8 10.2222C8.29469 10.2222 8.5773 10.3393 8.78567 10.5477C8.99405 10.756 9.11111 11.0386 9.11111 11.3333C9.11111 11.628 8.99405 11.9106 8.78567 12.119C8.5773 12.3274 8.29469 12.4444 8 12.4444C7.70532 12.4444 7.4227 12.3274 7.21433 12.119C7.00595 11.9106 6.88889 11.628 6.88889 11.3333C6.88889 11.0386 7.00595 10.756 7.21433 10.5477C7.4227 10.3393 7.70532 10.2222 8 10.2222ZM4.22222 6.66667C4.51691 6.66667 4.79952 6.78373 5.0079 6.9921C5.21627 7.20048 5.33333 7.48309 5.33333 7.77778C5.33333 8.07246 5.21627 8.35508 5.0079 8.56345C4.79952 8.77183 4.51691 8.88889 4.22222 8.88889C3.92754 8.88889 3.64492 8.77183 3.43655 8.56345C3.22817 8.35508 3.11111 8.07246 3.11111 7.77778C3.11111 7.48309 3.22817 7.20048 3.43655 6.9921C3.64492 6.78373 3.92754 6.66667 4.22222 6.66667ZM8 6.66667C8.29469 6.66667 8.5773 6.78373 8.78567 6.9921C8.99405 7.20048 9.11111 7.48309 9.11111 7.77778C9.11111 8.07246 8.99405 8.35508 8.78567 8.56345C8.5773 8.77183 8.29469 8.88889 8 8.88889C7.70532 8.88889 7.4227 8.77183 7.21433 8.56345C7.00595 8.35508 6.88889 8.07246 6.88889 7.77778C6.88889 7.48309 7.00595 7.20048 7.21433 6.9921C7.4227 6.78373 7.70532 6.66667 8 6.66667ZM11.7778 6.66667C12.0725 6.66667 12.3551 6.78373 12.5635 6.9921C12.7718 7.20048 12.8889 7.48309 12.8889 7.77778C12.8889 8.07246 12.7718 8.35508 12.5635 8.56345C12.3551 8.77183 12.0725 8.88889 11.7778 8.88889C11.4831 8.88889 11.2005 8.77183 10.9921 8.56345C10.7837 8.35508 10.6667 8.07246 10.6667 7.77778C10.6667 7.48309 10.7837 7.20048 10.9921 6.9921C11.2005 6.78373 11.4831 6.66667 11.7778 6.66667ZM13.1111 1.33333H2.88889C2.47633 1.33333 2.08067 1.49722 1.78895 1.78895C1.49722 2.08067 1.33333 2.47633 1.33333 2.88889V3.55556H14.6667V2.88889C14.6667 2.47633 14.5028 2.08067 14.2111 1.78895C13.9193 1.49722 13.5237 1.33333 13.1111 1.33333Z",
    })
  );
};

const ForwardRef = React.forwardRef(CalenderOutlineIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
